import React from "react"
import {useQuery} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import * as api from "api";

import Page from "../Page";
import WorkgroupsTable from "./WorkgroupsTable";
import useDataTable from "../../components/DataTable/useDataTable";
import MDButton from "../../materialDashboard/components/MDButton";
import MDBox from "../../materialDashboard/components/MDBox";
import Card from "@mui/material/Card";
import {useAuth} from "../../auth/AuthProvider";


const Workgroups = () => {
    const {t} = useTranslation(['workgroups']);
    const navigate = useNavigate();
    const {fetchDataOptions, ...tableState} = useDataTable({dataTableId: "workgroups"});
    const {workgroupAuthorization} = useAuth();

    const dataQuery = useQuery({
        queryKey: ['workgroups', fetchDataOptions],
        queryFn: () => api.Workgroup.getWorkgroups(fetchDataOptions),
        keepPreviousData: true
    })

    return <Page path={"/users"}>
        <MDBox mx={2}>
            {
                workgroupAuthorization.stations.create && <MDBox mb={2}>
                    <MDButton variant="gradient" color="info" onClick={() => navigate("/workgroups/new")}>
                        {t('newWorkgroup')}
                    </MDButton>
                </MDBox>
            }
            <Card>
                <WorkgroupsTable rows={dataQuery.data?.rows}
                                 page_count={dataQuery.data?.page_count}
                                 {...tableState}/>
            </Card>
        </MDBox>
    </Page>
}


export default Workgroups;